import React, { PureComponent } from 'react';
import './GridContent.less';

class GridContent extends PureComponent {
  render() {
    const { children } = this.props;
    return <div className='main-grid'>
      {children}
    </div>;
  }
}

export default GridContent;